var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 61,
    viewBox: "0 0 58 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5789 21.1883L58 36.6V42.7L33.5789 34.9957L31.5789 51.3437L40.7368 56.425V61L29 56.95L17.2632 61V56.425L26.4211 51.3406L24.4211 34.9926L0 42.7V36.6L24.4211 21.1883L25.4211 4.575C25.4211 2.08148 26.5077 0 29 0C31.4923 0 32.5789 2.08148 32.5789 4.575L33.5789 21.1883Z",
    fill: "#FF3956"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.0d8e70984f7e152c207622b45ee465c4.svg";
export { ForwardRef as ReactComponent };